import * as Yup from 'yup';
import { NetworkEnum } from '../../common/enum/network-enum';

const EVM_NETWORKS = [NetworkEnum.Ethereum, NetworkEnum.Base, NetworkEnum.Arbitrum, NetworkEnum.BNBChain];
const EVM_REGEX = /^0x[0-9a-fA-F]{40}$/;
const SOLANA_REGEX = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

export const CreateEditValidationSchema = () => {
    return Yup.object({
        walletName: Yup.string().required("Nome da carteira é obrigatório"),
        isActive: Yup.boolean().required("Flag activo é obrigatória"),
        isBalancedWallet: Yup.boolean().required("Flag carteira balanceada é obrigatório"),
        addresses: Yup.array().of(
            Yup.object({
                address: Yup.string()
                    .required("Endereço é obrigatório")
                    .test('valid-blockchain-address', 'Endereço blockchain inválido', function (value) {
                        const { network } = this.parent;
                        if (!value) return false;
                        if (EVM_NETWORKS.includes(network)) return EVM_REGEX.test(value);
                        if (network === NetworkEnum.Solana) return SOLANA_REGEX.test(value);
                        return true;
                    })
            })
        )
    });
}